import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=1d6367a8&"
import script from "@/scripts/AllCourses/index.js?vue&type=script&lang=js&"
export * from "@/scripts/AllCourses/index.js?vue&type=script&lang=js&"
import style0 from "./AllCourses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports